import React from 'react';

const CARDS = [
  {
    key: 'total',
    label: 'Total',
    icon: 'fas fa-building',
    valueClass: 'text-gray-900 dark:text-white',
    iconClass: 'text-gray-600 dark:text-gray-400',
  },
  {
    key: 'active',
    label: 'Active',
    icon: 'fas fa-check-circle',
    valueClass: 'text-green-600 dark:text-green-400',
    iconClass: 'text-green-600 dark:text-green-400',
  },
  {
    key: 'paused',
    label: 'Paused',
    icon: 'fas fa-pause-circle',
    valueClass: 'text-gray-600 dark:text-gray-400',
    iconClass: 'text-gray-600 dark:text-gray-400',
  },
  {
    key: 'withEndDate',
    label: 'With end-date set',
    icon: 'fas fa-calendar-times',
    valueClass: 'text-orange-600 dark:text-orange-400',
    iconClass: 'text-orange-600 dark:text-orange-400',
  },
];

const StatCards = ({ stats }) => {
  const safeStats = stats || {};

  return (
    <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-6">
      {CARDS.map((card) => (
        <div
          key={card.key}
          className="bg-white dark:bg-gray-800 rounded-xl p-6 border border-gray-200 dark:border-gray-700 shadow-lg hover:shadow-xl transition-all duration-300"
        >
          <div className="flex items-center mb-3">
            <i className={`${card.icon} ${card.iconClass} text-lg mr-3`}></i>
            <div className="text-sm text-gray-600 dark:text-gray-400">
              {card.label}
            </div>
          </div>
          <div
            data-testid={`stat-${card.key}`}
            className={`text-2xl font-bold ${card.valueClass}`}
          >
            {safeStats[card.key] || 0}
          </div>
        </div>
      ))}
    </div>
  );
};

export default StatCards;
